import { createContext, useContext } from 'react'
import type { ProjectRepository } from '@/domain/project/ProjectRepository'

export const RepositoryContext = createContext<ProjectRepository | null>(null)

export function useRepository(): ProjectRepository {
  const repo = useContext(RepositoryContext)
  if (!repo) {
    throw new Error('useRepository must be used inside <RepositoryProvider>')
  }
  return repo
}
